import React from "react"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbRte from "../ui-kit/dfb_rte"
import DfbButton from "../ui-kit/dfb_button"
import DfbCheckbox from "../ui-kit/dfb_checkbox"
import DfbInput from "../ui-kit/dfb_input"
import Section from "../blocks/section"
// ToDo: Funktionalität der Newsletter-Eintragen sicher stellen?
// ToDo: Quelle für das Bild klären/anpassen

class Newsletter extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      firstname: "",
      lastname: "",
      email: "",
      privacy_checked: true,
      min_age_checked: false,
      has_error: false,
      firstname_disabled: false,
      lastname_disabled: false,
      email_disabled: false,
      button_disabled: false,
      invalid_fields: [],
    }

    //ie11 doesnt have URL-API - stupid get hostname from url..
    this.service_host = process.env.NEWSLETTER_SERVICE_URL
    this.service_host = this.service_host
      .replace("https://", "")
      .replace("http://", "")
      .split("/")[0]

    this.origin_host = process.env.PUBLIC_CDN_HOST
    this.origin_host = this.origin_host
      .replace("https://", "")
      .replace("http://", "")
      .split("/")[0]

    this.invalidFieldMap = {
      mevEmail: "email",
      mevFirstname: "firstname",
      mevLastname: "lastname",
      mevAge: "min_age_checked",
      mevPrivacy: "privacy_checked",
    }

    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleErrors = this.handleErrors.bind(this)
    this.handleSuccess = this.handleSuccess.bind(this)
  }

  handleInputChange(event) {
    const target = event.target
    const value = target.type === "checkbox" ? target.checked : target.value
    const name = target.name
    this.setState({
      [name]: value,
    })
  }

  handleSubmit(event) {
    let ajaxUrl = process.env.NEWSLETTER_SERVICE_URL
    // privacy_checked is allways true
    // if (!this.state.privacy_checked) {
    //   this.handleErrors([this.invalidFieldMap.mevPrivacy])
    //   event.preventDefault()
    //   return false
    // }

    this.setState({
      firstname_disabled: true,
      lastname_disabled: true,
      email_disabled: true,
      button_disabled: true,
    })

    let cfd = {}
    cfd.mevRegistration = "1"
    cfd.mevAge = this.state.min_age_checked ? "on" : "off"
    cfd.mevFirstname = this.state.firstname
    cfd.mevLastname = this.state.lastname
    cfd.mevEmail = this.state.email

    let serializedContentForm = Object.keys(cfd)
      .map(function (key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(cfd[key])
      })
      .join("&")

    let pfd = new FormData()

    pfd.append("version", "1.7")
    pfd.append("opts[ajax]", "json")
    pfd.append("opts[mode]", "headless")
    pfd.append("opts[loadingbar]", "false")
    pfd.append("opts[preface]", "")
    pfd.append("opts[host]", this.service_host)
    pfd.append("opts[crmsource]", this.origin_host)
    pfd.append("opts[crmscope]", "r-9")
    pfd.append("opts[crmaccount]", "")
    pfd.append("opts[crmid]", "")
    pfd.append("newadd[]", "122")
    pfd.append("form", serializedContentForm)

    let xhr = new XMLHttpRequest()
    xhr.open("POST", ajaxUrl)
    let self = this
    xhr.onload = function () {
      if (xhr.status === 200) {
        self.handleSuccess()
      } else {
        let respJSON = JSON.parse(xhr.responseText)
        let errorFields = respJSON.client.validationErrors
          .map(function (error) {
            if (self.invalidFieldMap[error]) {
              return self.invalidFieldMap[error]
            } else {
              return null
            }
          })
          .filter(function (el) {
            return el !== null
          })
        self.handleErrors(errorFields)
      }
    }
    xhr.send(pfd)
    event.preventDefault()
  }

  handleErrors(errorFields) {
    this.setState({
      firstname_disabled: false,
      lastname_disabled: false,
      email_disabled: false,
      button_disabled: false,
      has_error: true,
      invalid_fields: errorFields,
    })
  }

  handleSuccess() {
    this.props.onSuccess()
  }

  render() {
    const { data } = this.props
    const {
      baseClass,
      defaultPadding,
      image,
      headline,
      darkTheme,
      text,
      firstname_placeholder,
      firstname_error_label,
      lastname_placeholder,
      lastname_error_label,
      email_placeholder,
      email_error_label,
      consent_text,
      age_consent_text,
      success_headline,
      success_text,
    } = data

    return (
      <Section
        baseClass={baseClass}
        defaultPadding={defaultPadding}
        className={this.state.has_error ? ` ${baseClass}--error` : undefined}
        data={data}
      >
        {image && (
          <img
            className={`${baseClass}-img`}
            src={image.src}
            alt={image.alt}
            data-object-fit
          />
        )}
        <div className={`${baseClass}-wrapper`}>
          <div className={`${baseClass}-container`}>
            <div className={`${baseClass}-text`}>
              {headline && (
                <DfbHeadline
                  headline={headline}
                  headline_level="h2"
                  add_class={`${
                    darkTheme ? "u-Theme-dark" : ""
                  } ${baseClass}-header`}
                />
              )}
              {text && (
                <DfbRte
                  text={`<p>${text}</p>`}
                  add_class={`${
                    darkTheme ? "u-Theme-dark" : ""
                  } ${baseClass}-subline`}
                />
              )}
            </div>
            <form className={`${baseClass}-form`} onSubmit={this.handleSubmit}>
              <div className={`${baseClass}-inputFirstname`}>
                <DfbInput
                  name="firstname"
                  label={firstname_placeholder}
                  onChange={this.handleInputChange}
                  disabled={this.state.firstname_disabled}
                  focused={this.state.firstname !== "" ? true : false}
                  add_class={`${darkTheme ? "u-Theme-dark" : ""}`}
                  type="text"
                  errorMessage={
                    this.state.invalid_fields.indexOf("firstname") !== -1
                      ? firstname_error_label
                      : null
                  }
                />
              </div>
              <div className={`${baseClass}-inputLastname`}>
                <DfbInput
                  name="lastname"
                  label={lastname_placeholder}
                  onChange={this.handleInputChange}
                  disabled={this.state.lastname_disabled}
                  focused={this.state.lastname !== "" ? true : false}
                  add_class={`${darkTheme ? "u-Theme-dark" : ""}`}
                  type="text"
                  errorMessage={
                    this.state.invalid_fields.indexOf("lastname") !== -1
                      ? lastname_error_label
                      : null
                  }
                />
              </div>
              <div className={`${baseClass}-inputEmail`}>
                <DfbInput
                  name="email"
                  label={email_placeholder}
                  onChange={this.handleInputChange}
                  disabled={this.state.email_disabled}
                  focused={this.state.email !== "" ? true : false}
                  add_class={`${darkTheme ? "u-Theme-dark" : ""}`}
                  type="text"
                  errorMessage={
                    this.state.invalid_fields.indexOf("email") !== -1
                      ? email_error_label
                      : null
                  }
                />
              </div>
              <div className={`${baseClass}-privacy`}>
                <div
                  className={`dfb-Rte ${darkTheme ? "u-Theme-dark" : ""}`}
                  dangerouslySetInnerHTML={{
                    __html: "<p>" + consent_text + "</p>",
                  }}
                ></div>
              </div>
              <div className={`${baseClass}-privacy`}>
                <DfbCheckbox
                  add_class={`${darkTheme ? "u-Theme-dark" : ""}`}
                  name="min_age_checked"
                  text={age_consent_text}
                  onChange={this.handleInputChange}
                  error={
                    this.state.invalid_fields.indexOf("min_age_checked") !== -1
                      ? true
                      : false
                  }
                />
              </div>
              <div className={`${baseClass}-button`}>
                <DfbButton
                  text="Anmelden"
                  type="submit"
                  disabled={this.state.button_disabled}
                  add_class={`${darkTheme ? "u-Theme-dark" : ""}`}
                />
              </div>
            </form>
            {success_headline && (
              <div className={`${baseClass}-successMessage`}>
                <DfbHeadline
                  headline={success_headline}
                  headline_level="h2"
                  add_class={`${
                    darkTheme ? "u-Theme-dark" : ""
                  } ${baseClass}-header`}
                />
                <DfbRte
                  add_class={`${darkTheme ? "u-Theme-dark" : ""}`}
                  text={`<p>${success_text}</p>`}
                />
              </div>
            )}
          </div>
        </div>
      </Section>
    )
  }
}

export default Newsletter
